// extracted by mini-css-extract-plugin
export default {"select_popup":"styles_select_popup__PWPtJ","button_redirect":"styles_button_redirect__dLOTH"};